import awsRegions from "../aws/regions";

import {ReactComponent as AWS} from "ui-components-rollup/src/images/third-party-services/color_logo_aws.svg";
import styles from "./Styles.module.scss";
import {ReactComponent as Azure} from "ui-components-rollup/src/images/third-party-services/color_logo_azure.svg";
import {ReactComponent as GCP} from "ui-components-rollup/src/images/third-party-services/color_logo_gcp.svg";
import {ReactComponent as OnPrem} from "ui-components-rollup/src/images/third-party-services/color_logo_onprem.svg";

const allRegions = {
    aws: awsRegions
}

export const regionLabel = (provider, regionOrLocation) => {
    return allRegions[provider]?.[regionOrLocation] || regionOrLocation;
}

export const providersMap = {
    aws: { label: "AWS", longLabel: "Amazon Web Services", icon: AWS, tableIconClassName: styles['aws-icon'] },
    azure: { label: "Azure", longLabel: "Microsoft Azure", icon: Azure, tableIconClassName: styles['azure-icon'] },
    gcp: { label: "Google Cloud", longLabel: "Google Cloud Platform", icon: GCP, tableIconClassName: styles['gcp-icon'] },
    "on-prem": { label: "On-Premises", longLabel: "On-Premises", icon: OnPrem, tableIconClassName: styles['on-prem-icon'] }
};
